import i18n from '@/plugins/i18n';
import { BaseNotification } from '@notify/models/notification/types/base';
import router from '@/plugins/vue-router';

export class DatabaseExportComplete extends BaseNotification {
  constructor(data) {
    super(data);
  }
  getTheme() {
    return BaseNotification.THEME_INFO;
  }
  getText() {
    const props = this.getI18nProps();
    const route = { name: 'notify.notification.index' };
    const link_href = router.resolve(route).href;
    const link_tag = `<a href="${link_href}">${props.text_link}</a>`;
    return `${props.text_body} ${link_tag}`;
  }

  getI18nProps() {
    const path = this.params.path || false;
    const filename = getFilenameByPath(this.params.path) || 'export.csv';
    return {
      path,
      text_body: i18n.t('notify.notification.export_complete.body'),
      text_link: i18n.t('notify.notification.export_complete.link'),
      filename
    };
  }
}

function getFilenameByPath(path) {
  const split = path.split('/');
  if (split.length > 0) {
    return split[split.length - 1];
  }
  return false;
}
